import { gql } from '@/__generated__';

export const GET_GATE_MOVEMENTS_HISTORY = gql(`#graphql
  query GetGateMovementsHistory($gateId: ID!, $limit: Int!, $offset: Int!) {
    gate(input: { id: $gateId }) {
      id
      movements2 {
        id
        unit
        precision
        history(pagination: { limit: $limit, offset: $offset }) {
          items { ...GateMovementHistoryFragment }
          pageInfo { count totalCount pageNumber limit offset }
        }
      }
    }
  }
`);
